export const SUPPLIER_TYPES = {
  talentVendor: 'talent_vendor',
  staffingAgency: 'staffing_agency',
  recruitingAgency: 'recruiting_agency',
};

export const supplierTypesNames = {
  [SUPPLIER_TYPES.talentVendor]: 'Talent vendor',
  [SUPPLIER_TYPES.staffingAgency]: 'Staffing agency',
  [SUPPLIER_TYPES.recruitingAgency]: 'Recruiting agency',
};

export const supplierTypesOptions = [
  {
    key: 'talent_vendor',
    label: supplierTypesNames['talent_vendor'],
    value: SUPPLIER_TYPES.talentVendor,
  },
  {
    key: 'staffing_agency',
    label: supplierTypesNames['staffing_agency'],
    value: SUPPLIER_TYPES.staffingAgency,
  },
  {
    key: 'recruiting_agency',
    label: supplierTypesNames['recruiting_agency'],
    value: SUPPLIER_TYPES.recruitingAgency,
  },
];
